import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import clientsImg from "../assets/clients.jpg";

export default function ClientsSection() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section
      className="MainBodySection"
      style={{
        padding: "90px 0",
        background: "#f8f9fb",
      }}
    >
      <div className="container">

        {/* Section Header */}
        <div className="row justify-content-center mb-5 text-center">
          <div className="col-lg-8">
            <h2 className="font-bold mb-3">Our Clients</h2>
            <p
              className="text-dim"
              style={{
                maxWidth: "680px",
                margin: "0 auto",
                lineHeight: 1.6,
              }}
            >
              We are trusted by homeowners, businesses, contractors, and institutions
              across Tanzania to deliver quality, reliability, and craftsmanship.
            </p>
          </div>
        </div>

        {/* Full Width Image */}
        <div className="row justify-content-center">
          <div className="col-12">
            <div
              style={{
                borderRadius: "24px",
                overflow: "hidden",
                boxShadow: "0 18px 45px rgba(0,0,0,0.12)",
              }}
            >
              <img
                src={clientsImg}
                alt="Kitchen Kings TZ Clients"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
